import * as tslib_1 from "tslib";
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { CardQuery, CardOptionQuery, BinNumberQuery, cardCheckActions } from '@awp/nac/card-check/api';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { isNullOrEmpty } from '@awp/core/utils';
import { ApiInsuranceType } from '@awp/quote/models';
var CardQuoteCheckComponent = /** @class */ (function () {
    function CardQuoteCheckComponent(cardQuery, cardOptionQuery, binQuery, store, changeDetectorRef) {
        this.cardQuery = cardQuery;
        this.cardOptionQuery = cardOptionQuery;
        this.binQuery = binQuery;
        this.store = store;
        this.changeDetectorRef = changeDetectorRef;
        this.showBinNotFound = false;
        this.showAlternativeBinFound = false;
    }
    Object.defineProperty(CardQuoteCheckComponent.prototype, "context", {
        get: function () {
            return this._context;
        },
        set: function (value) {
            this._context = value;
            this.resetBin();
            this.changeDetectorRef.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    CardQuoteCheckComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.binQuery.values
            .pipe(untilDestroyed(this))
            .subscribe(function (p) {
            _this.showBinNotFound = (!isNullOrEmpty(p.binNumber) && p.binFound === false);
            _this.showAlternativeBinFound = (!isNullOrEmpty(p.binNumber) && p.alternativeBin === true);
        });
    };
    CardQuoteCheckComponent.prototype.ngOnDestroy = function () { };
    CardQuoteCheckComponent.prototype.onCardSelected = function (card) {
        var selectedCard = tslib_1.__assign({}, card, { clientId: this.context.theme.themeId });
        this.store.dispatch(new cardCheckActions.SelectCardTypeAction({ card: selectedCard, insuranceType: ApiInsuranceType.TravelInsurance }));
    };
    CardQuoteCheckComponent.prototype.onBinSearch = function (bin) {
        this.store.dispatch(new cardCheckActions.BinSearchAction(bin, ApiInsuranceType.TravelInsurance));
    };
    CardQuoteCheckComponent.prototype.resetBin = function () {
        this.store.dispatch(new cardCheckActions.ResetBinSearch());
        this.showBinNotFound = false;
        this.showAlternativeBinFound = false;
    };
    CardQuoteCheckComponent.prototype.onClearNoBinError = function () {
        this.showBinNotFound = false;
    };
    CardQuoteCheckComponent.prototype.onClearAlternativeBinError = function () {
        this.showAlternativeBinFound = false;
    };
    return CardQuoteCheckComponent;
}());
export { CardQuoteCheckComponent };
